import {imageUpload} from '../api/api'
let mixinUploadImage = {
  data () {
    return {

    }
  },
  methods: {
    // 读取图片转换成base64
    readFile (file) {
      return new Promise((resolve, reject) => {
        let imagefile = file.type
        let reader = new FileReader()
        let match = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif']
        let base64 = ''

        // 判断文件类型
        if (!((imagefile === match[0]) || (imagefile === match[1]) || (imagefile === match[2]) || (imagefile === match[3]))) {
          this.$notify({
            title: '失败',
            message: '请选择正确的图片类型',
            type: 'error'
          })
          reject(new Error('type error'))
        }

        let that = this
        reader.onload = function (e) {
          base64 = this.result
          that.uploadImage(base64).then(res => {
            resolve(res)
          })
        }
        reader.readAsDataURL(file)
      })
    },
    // 上传图片
    uploadImage (base64) {
      return new Promise((resolve, reject) => {
        let params = {
          icon_str: base64
        }

        if (this.itype !== '') {
          params.itype = this.itype
        }

        if (this.filename !== '') {
          params.filename = this.filename
        }

        imageUpload(params).then(res => {
          let data = res.data || {c: -1}
          if (!data.c) {
            resolve(data.d.url)
          } else {
            this.$notify({
              title: '失败',
              message: '错误码：' + data.c,
              type: 'error'
            })
            resolve('')
          }
        }).catch(err => {
          this.$notify({
            title: '失败',
            message: err,
            type: 'error'
          })
          resolve('')
        })
      })
    }
  }
}

export default mixinUploadImage



// WEBPACK FOOTER //
// ./src/mixins/uploadImage.js